import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) { }
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  updateUser(data): Observable<any> {
    const url = environment.apiUrl + `/user/updateProfile`;
    return this.http.post<any>(url, data, this.httpOptions);
  }

  getUserAccount(): Observable<any> {
    const url = environment.apiUrl + `/user/getUserAccount`;
    return this.http.get<any>(url, this.httpOptions);
  }

  getUserBetList(data): Observable<any> {
    const url = environment.apiUrl + `/bets/getUserBetList`;
    return this.http.post<any>(url, data, this.httpOptions);
  }

  // Paris across products: { products, couponStatus, gte, lte, from, size }
  // → { data, total }. `products` always comes from VISIBLE_PRODUCTS
  // (account/shared/history-products.ts).
  getUserBetHistory(data: {
    products: string[];
    couponStatus: string;
    gte: number;
    lte: number;
    from: number;
    size: number;
  }): Observable<any> {
    const url = environment.apiUrl + `/bets/getUserBetHistory`;
    return this.http.post<any>(url, data, this.httpOptions);
  }

  // Paris totals for the same products and date window.
  getBetHistoryStats(data: {
    products: string[];
    gte: number;
    lte: number;
  }): Observable<any> {
    const url = environment.apiUrl + `/bets/getBetHistoryStats`;
    return this.http.post<any>(url, data, this.httpOptions);
  }

  // One provider round of the signed-in player: { success: { data } }, or the
  // coupon-not-found envelope { error } for a missing or foreign round.
  getProviderRoundDetail(data: { roundId: number }): Observable<any> {
    const url = environment.apiUrl + `/bets/getProviderRoundDetail`;
    return this.http.post<any>(url, data, this.httpOptions);
  }

  getUserEmailByUsername(data): Observable<any> {
    const url = environment.apiUrl + `/user/getUserEmailByUsername`;
    return this.http.post<any>(url, data, this.httpOptions);
  }

  completeActivation(data): Observable<any> {
    const url = environment.apiUrl + `/user/completeActivation`;
    return this.http.post<any>(url, data, this.httpOptions);
  }

  getUserTransactions(data): Observable<any> {
    const url = environment.apiUrl + `/transactions/getUserTransactions`;
    return this.http.post<any>(url, data, this.httpOptions);
  }

  getUserCryptoTransactions(data: {
    paymentStatus: string;
    fromDate: string;
    toDate: string;
    from: number;
    size: number;
  }): Observable<any> {
    const url = environment.apiUrl + `/crypto-payment/transactions`;
    return this.http.post<any>(url, data, this.httpOptions);
  }

  getCouponDetailById(data): Observable<any> {
    const url = environment.apiUrl + `/bets/getCouponDetailById`;
    return this.http.post<any>(url, data, this.httpOptions);
  }

  // Public detail of a coupon on the top winnings list. getCouponDetailById
  // only answers the coupon's owner.
  getTopCouponDetail(data): Observable<any> {
    const url = environment.apiUrl + `/bets/getTopCouponDetail`;
    return this.http.post<any>(url, data, this.httpOptions);
  }

  getUserBetsByRaceId(data): Observable<any> {
    const url = environment.apiUrl + `/bets/getUserBetsByRaceId`;
    return this.http.post<any>(url, data, this.httpOptions);
  }

  cancelCouponById(data) {
    const url = environment.apiUrl + `/bets/cancelCoupon`;
    return this.http.post<any>(url, data, this.httpOptions);
  }
}
